import { useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import Header from "@/components/layout/Header";
import Sidebar from "@/components/layout/Sidebar";
import AnalyticsPage from "@/pages/AnalyticsPage";
import AssetSectionPlaceholderPage from "@/pages/assets/AssetSectionPlaceholderPage";
import DashboardPage from "@/pages/DashboardPage";
import EventLogsPage from "@/pages/EventLogsPage";
import RenderCatalogPage from "@/pages/RenderCatalogPage";
import SettingsPage from "@/pages/SettingsPage";
import LoginPage from "@/pages/auth/LoginPage";
import LegacyRenderRedirect from "@/pages/render/LegacyRenderRedirect";
import RenderCatalogDetailPage from "@/pages/render/RenderCatalogDetailPage";
import UsersPage from "@/pages/UsersPage";
import { useAuthStore } from "@/stores/auth";

function App() {
  const { isAuthenticated, user } = useAuthStore();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const isAdmin = user?.role === "admin";

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-background text-foreground">
        <Routes>
          <Route path="/" element={<Navigate to="/assets/clothes" replace />} />
          <Route
            path="/clothing"
            element={<Navigate to="/assets/clothes" replace />}
          />
          <Route
            path="/pricing"
            element={<Navigate to="/assets/clothes" replace />}
          />
          <Route
            path="/assets"
            element={<Navigate to="/assets/clothes" replace />}
          />
          <Route path="/assets/clothes" element={<RenderCatalogPage />}>
            <Route
              path=":collection/:gender/:kind/:slotId/:drawableLocalIndex/:meshPartIndex/:assetId"
              element={<RenderCatalogDetailPage />}
            />
          </Route>
          <Route
            path="/render"
            element={<Navigate to="/assets/clothes" replace />}
          />
          <Route
            path="/render/clothes/:collection/:gender/:kind/:slotId/:drawableLocalIndex/:meshPartIndex/:assetId"
            element={<LegacyRenderRedirect />}
          />
          <Route
            path="/render/*"
            element={<Navigate to="/assets/clothes" replace />}
          />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<LoginPage />} />
          <Route path="*" element={<Navigate to="/assets/clothes" replace />} />
        </Routes>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />

      <div
        className={`transition-all duration-300 ease-in-out ${sidebarOpen ? "lg:ml-72" : "lg:ml-20"}`}
      >
        <Header
          user={user}
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />

        <main className="min-h-[calc(100vh-4rem)] px-4 py-4 lg:px-6 lg:py-6">
          <div className="mx-auto max-w-[1680px]">
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route
                path="/clothing"
                element={<Navigate to="/assets/clothes" replace />}
              />
              <Route
                path="/pricing"
                element={<Navigate to="/assets/clothes" replace />}
              />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/logs" element={<EventLogsPage />} />
              <Route
                path="/assets"
                element={<Navigate to="/assets/clothes" replace />}
              />
              <Route path="/assets/clothes" element={<RenderCatalogPage />}>
                <Route
                  path=":collection/:gender/:kind/:slotId/:drawableLocalIndex/:meshPartIndex/:assetId"
                  element={<RenderCatalogDetailPage />}
                />
              </Route>
              <Route
                path="/assets/vehicles"
                element={<AssetSectionPlaceholderPage title="Vehicles" />}
              />
              <Route
                path="/assets/objects"
                element={<AssetSectionPlaceholderPage title="Objects" />}
              />
              <Route
                path="/assets/maps"
                element={<AssetSectionPlaceholderPage title="Maps" />}
              />
              <Route
                path="/render"
                element={<Navigate to="/assets/clothes" replace />}
              />
              <Route
                path="/render/clothes/:collection/:gender/:kind/:slotId/:drawableLocalIndex/:meshPartIndex/:assetId"
                element={<LegacyRenderRedirect />}
              />
              <Route
                path="/render/*"
                element={<Navigate to="/assets/clothes" replace />}
              />
              <Route path="/settings" element={<SettingsPage />} />
              <Route
                path="/users"
                element={
                  isAdmin ? (
                    <UsersPage />
                  ) : (
                    <Navigate to="/dashboard" replace />
                  )
                }
              />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
        </main>
      </div>
    </div>
  );
}

export default App;
